<template>
  <div>
    <new-truck-modal />
    <CancelOrderModal />
    <NotesModal />
    <UnscheduleDeliveryModal />
    <AdvancedSearchModal />
    <ManageFacilitySavedSearchesModal />
    <DeliveryExportModal />
	  <DocumentUploadModal />
    <BarcodeSystemCurrentFacilityModal />
    <ManifestViewModal />
    <BarcodeOrderViewModal />
    <InventoryItemViewModal />
    <PalletViewModal />
    <CompletedOrderExportModal />
    <CustomerOnHoldModal />
  </div>
</template>

<script>
import NewTruckModal from "./NewTruckModal";
import CancelOrderModal from "./CancelOrderModal";
import NotesModal from "./NotesModal";
import UnscheduleDeliveryModal from "./UnscheduleDeliveryModal";
import AdvancedSearchModal from "./AdvancedSearchModal";
import ManageFacilitySavedSearchesModal from "./ManageFacilitySavedSearchesModal";
import DeliveryExportModal from "./DeliveryExportModal";
import CompletedOrderExportModal from "./CompletedOrderExportModal";
import DocumentUploadModal from "./DocumentUploadModal";
import BarcodeSystemCurrentFacilityModal from "./BarcodeSystemCurrentFacilityModal";
import ManifestViewModal from "./ManifestViewModal";
import BarcodeOrderViewModal from "./BarcodeOrderViewModal";
import InventoryItemViewModal from "./InventoryItemViewModal";
import PalletViewModal from "./PalletViewModal";
import CustomerOnHoldModal from "./CustomerOnHoldModal";

export default {
  name: "GlobalModals",
  components: {
    NewTruckModal,
    NotesModal,
    CancelOrderModal,
    UnscheduleDeliveryModal,
    AdvancedSearchModal,
    ManageFacilitySavedSearchesModal,
    DeliveryExportModal,
    CompletedOrderExportModal,
    BarcodeSystemCurrentFacilityModal,
    ManifestViewModal,
    BarcodeOrderViewModal,
    InventoryItemViewModal,
    PalletViewModal,
	  DocumentUploadModal,
    CustomerOnHoldModal
  }
};
</script>
